

































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestPaper from "@/store/entities/testPaper";
import url from "@/lib/url";
//import ewebeditor from "@/components/ewebeditor.vue";

@Component({
  components: {},
})
export default class EditTestPaper extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  testPaper: TestPaper = new TestPaper();

  formTitle: string = "作业修改";
  isCreate: boolean = true;
  editorContentConfig: any = {
    style: 'coolblue',
    width: '100%',
    height: '200px'
  };
  frontendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  editorBackendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  data: any = [];
  valueArray: any = [];
  testpaperdescription: string = "";
  screenWidth: number = document.body.clientWidth - 200;
  get isGeneral() {
    return sessionStorage.getItem("isGeneral") == "true" ? 1 : 0;
  }
  setEditorData() {
    (this.$refs["editewe"] as any).setHtmleweb(this.testpaperdescription);
  }

  cascaderSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.testPaper.sectionId = selectedData[selectedData.length - 1].id;
    else this.testPaper.sectionId = null;
  }

  save() {
    (this.$refs.testPaperForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "testPaper/update",
          data: this.testPaper,
        });
        (this.$refs.testPaperForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    this.data = this.$store.state.testPaper.cascaders.items;
    if (!value) {
      this.testPaper = new TestPaper();
      this.$store.state.testPaper.editTestPaper = this.testPaper;
      (this.$refs.testPaperForm as any).resetFields();
      this.$emit("input", value);
    } else {
      this.testPaper = Util.extend(
        true,
        {},
        this.$store.state.testPaper.editTestPaper
      );
      if (this.testPaper.id) {
        this.isCreate = false;
        this.formTitle = "作业修改";
        this.testpaperdescription =
          this.$store.state.testPaper.editTestPaper.description;
        this.valueArray =
          this.$store.state.testPaper.editTestPaper.categoryList;
        this.setEditorData();
      }
    }
  }

  testPaperRule = {
    name: [
      {
        required: true,
        message: this.L("该项不能为空", undefined, "试卷名称"),
        trigger: "blur",
      },
      {
        type: "string",
        min: 2,
        max: 200,
        message: "作业名称为2-200个字符",
        trigger: "blur",
      },
    ],
  };
}
